/* ---------------------------------------

    -- マウス動作に合わせていい感じに値を返すやつ

--------------------------------------- */

export default class MouseManager{
    constructor(manager){

        //manager
        this.manager = manager;

        //dom
        this.$pointer = document.getElementById("l-pointer");
        this.$pointerCircle = document.getElementById("l-pointer-circle");
        this.$pointerClose = document.getElementById("l-pointer-close");
        this.$hover = document.querySelectorAll(".js__pointer-hover");

        this.status={
            off : Useragnt.mobile || this.manager.isIpad ? true : false,
            pointer : {
                show:false,//ポインター表示しているか
                enter:false,
                color:'gray',
            },
            mode:"",
        }

        /* ポインターの位置情報 */
        this.pointer = {
            x : 0,
            y : 0
        }
        /* 慣性動作後の値 */
        this.obj = {
            x : 0,
            y : 0
        }

        /* 設定はここ */
        this.conf = {
            ease : 0.1,
        }

    }
    init(){

        //dom
        this.$pointer = document.getElementById("l-pointer");
        this.$pointerCircle = document.getElementById("l-pointer-circle");
        this.$pointerClose = document.getElementById("l-pointer-close");
        this.$hover = document.querySelectorAll(".js__pointer-hover");

        if(!(Useragnt.mobile || this.manager.isIpad)){

            //reset
            this.status.pointer.enter = false;
            this.iconChange("leave");

            // link関係のホバー
            for(let i in this.$hover) {
                if (this.$hover[i].nodeType != 1) continue; // dom要素以外は処理止める

                this.$hover[i].addEventListener("mouseover", (e) => {

                    if(this.status.pointer.enter) return;

                    this.status.pointer.enter = true;

                    if(this.$hover[i].classList.contains("type-normal")){
                        this.iconChange("normal");
                    }else if(this.$hover[i].classList.contains("type-close")){
                        this.iconChange("close");
                    }

                });

                this.$hover[i].addEventListener("mouseleave", (e) => {

                    if(!e.target.classList.contains("js__pointer-hover")) return;

                    this.status.pointer.enter = false;

                    if(e.target.classList.contains("type-normal") || e.target.classList.contains("type-close")){
                        this.iconChange("leave");
                    }

                });
            }

            // メニューに乗った時はホワイトに
            this.manager.menu.$wrap.addEventListener("mouseover", (e) => {
                this.iconChange("white");
            });
            this.manager.menu.$wrap.addEventListener("mouseleave", (e) => {
                this.iconChange("gray");
            });

        }

    }
    move(type){ /* domにスタイル付けるなら("set",$target) | 値が欲しいだけなら()なし */

        if(this.status.off) return;

        this.obj.x += (this.pointer.x-this.obj.x)*this.conf.ease;
        this.obj.y += (this.pointer.y-this.obj.y)*this.conf.ease;

        TweenLite.set(this.$pointer,{
            x : this.obj.x,
            y : this.obj.y
        })

    }
    iconChange(type) {

        if(type === 'close'){
            TweenLite.to(this.$pointerCircle, 0.6 ,{
                width:'45px',
                height:'45px',
                x:-12,
                ease:this.manager.ease,
            });
            TweenLite.to(this.$pointerClose, 0.6 ,{
                opacity:1,
                ease:this.manager.ease,
            });
        }
        if(type === 'normal'){
            TweenLite.to(this.$pointerCircle, 0.6 ,{
                width:'45px',
                height:'45px',
                x:-12,
                ease:this.manager.ease,
            });
            TweenLite.to(this.$pointerClose, 0.6 ,{
                opacity:0,
                ease:this.manager.ease,
            });
        }
        if(type === 'leave'){
            TweenLite.to(this.$pointerCircle, 0.6 ,{
                width:'20px',
                height:'20px',
                x:0,
                ease:this.manager.ease,
            });
            TweenLite.to(this.$pointerClose, 0.6 ,{
                opacity:0,
                ease:this.manager.ease,
            });
        }
        if(type === 'white'){
            TweenLite.to(this.$pointerCircle, 0.6 ,{
                css:{
                    'background-color':'rgba(255,255,255,0.58)'
                },
                ease:this.manager.ease,
            });
        }
        if(type === 'gray'){
            TweenLite.to(this.$pointerCircle, 0.6 ,{
                css:{
                    'background-color':'rgba(174, 181, 187, 0.78)'
                },
                ease:this.manager.ease,
            });
        }

    }
    fit($target){

        if(this.status.off||this.status.deviceSize=="sp"||Useragnt.mobile||this.manager.isIpad) return;

        if(mode=="move"){
            let _w = $target.clientWidth,
                _h = $target.clientHeight,
                _rect = $target.getBoundingClientRect(),
                _x = _rect.left,
                _y = _rect.top,
                _fx = (this.pointer.x - _x) / _w - 0.5,
                _fy = (this.pointer.y - _y) / _h - 0.5;

            TweenLite.to($target.querySelectorAll(".js__m-fit"),0.2,{
                x:_w<100?_fx * _w * 0.5:_fx * _w * 0.07,
                y:_h<100?_fy * _h * 0.5:_fy * _h * 0.07
            });

        }else{

            TweenLite.to($target.querySelectorAll(".js__m-fit"),0.2,{
                x:0,
                y:0
            });
        }

    }
    update(x,y){
        if(this.status.off) return;

        if(Useragnt.pc){
            this.pointer.x = x;
            this.pointer.y = y;
        }else{
            this.pointer.x = x;
            this.pointer.y = -y;
        }
    }
}